import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ScrollToTop from './utils/scrollToTop';
import BackToTopButton from './utils/backToTopBtn';

import Lenis from '@studio-freight/lenis';
import { useEffect } from 'react';

import './App.css';

import PlayPage from './pages/PlayPage';
import LandingPage from './pages/LandingPage';
import LearnPage from './pages/LearnPage';

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1,
      smooth: true,
      direction: 'vertical',
    });
  
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
  
    requestAnimationFrame(raf);
  }, []);
  
  return (
    <Router>
      <ScrollToTop/>
      <BackToTopButton />

      <Routes>
        
        <Route path="/" element={<LandingPage />} />
        <Route path="/learn" element={<LearnPage />} />
        <Route path="/play" element={<PlayPage />} />

      </Routes>
    </Router>
  );
}

export default App;